import React from 'react'
import ErrorLayout from '@components/layouts/ErrorLayout'

const Page: React.FC = () => {
  return (
    <ErrorLayout>
      <h1 className="text-white">Page Not Found</h1>
    </ErrorLayout>
  )
}

export default Page
